// Section file — embudo de tráfico frío /50off.
// Debe mantener un árbol de claves IDÉNTICO a en.fiftyoff.js.

const lang = {
  fiftyoff: {
    bannerPrefix: "Tiempo limitado:",
    bannerOff: "50% de descuento",
    bannerEndsIn: "termina en",
    trustedBy: "Más de 50,000 creadores confían en nosotros",
    // El paquete es de compra única; el servicio de reposición automática que
    // lo acompaña se renueva por $19.99 (7 días, luego cada 28). Nada aquí
    // puede afirmar que no se volverá a cobrar, ni prometer entregas mensuales
    // del paquete en sí.
    heroHeading: "Consigue seguidores reales en tu cuenta hoy",
    heroSub:
      "Elige cuántos seguidores quieres y los entregamos en tu Instagram, TikTok o X. Compra única — 50% de descuento solo por hoy.",
    perMonth: "/mes",
    followersPerMonth: (range) => `${range} seguidores`,
    // Niveles de calidad, elegidos después del paquete.
    quality: {
      heading: "Elige la calidad de tus seguidores",
      tiers: {
        high: {
          name: "Seguidores de alta calidad",
          badge: "Mejor valor",
          desc: "Son seguidores con foto de perfil pero sin más publicaciones en su cuenta. La reposición automática está activa dentro de la garantía.",
          features: [
            "Seguidores auténticos afines a tu nicho",
          ],
        },
        active: {
          name: "Seguidores activos",
          badge: "Popular",
          desc: "Los nuevos seguidores activos son para quienes se toman en serio su crecimiento en Instagram. Están respaldados por nuestra garantía de reposición para mayor tranquilidad.",
          features: [
            "Seguidores reales y activos",
            "Soporte prioritario",
          ],
        },
        vip: {
          name: "Seguidores Exclusivos/VIP",
          badge: "Premium",
          desc: "¡Para nuestros instagramers más VIP! Los seguidores VIP son nuestros paquetes de mayor calidad, todos segmentados en Norteamérica y muy activos, con interacción real, historias interactivas, carruseles dinámicos, sin perfiles fantasma, y con 5-10x más seguidores que seguidos.",
          features: [
            "Seguidores segmentados con IA para un crecimiento fuerte",
            "Soporte prioritario",
          ],
        },
      },
    },
    mostPopular: "Más popular",
    gainWillGain: (u) => `@${u} ganará:`,
    gainNewCount: "Nuevo total de seguidores:",
    gainFollowers: "Seguidores",
    continueBtn: "Continuar",
    changeBtn: "Cambiar",
    doneBtn: "Listo",
    accountLabel: "Cuenta a hacer crecer",
    cardAccordion: "Pagar con tarjeta de crédito o débito",
    startMyGrowth: "Comenzar mi crecimiento",
    startGrowing: "Empieza a crecer",
    secureLine: "Pago seguro · Cancela la reposición cuando quieras",
    guaranteeHeading: "Garantía de devolución de 7 días",
    guaranteeBody: "Prueba ViralGPT sin riesgo. Si no estás completamente satisfecho en 7 días, te devolvemos todo tu dinero—",
    guaranteeBold: "sin preguntas.",
    changePlan: "Cambiar plan",
    offApplied: "50% de descuento de lanzamiento aplicado",
    billingHeading: "Comienza tu crecimiento",
    emailLabel: "Correo electrónico",
    emailPlaceholder: "tu@correo.com",
    platformLabel: "Plataforma",
    usernameLabel: (platform) => `Usuario de ${platform}`,
    usernamePlaceholder: "@usuario",
    cardLabel: "Número de tarjeta",
    expirationLabel: "Vencimiento",
    cvcLabel: "CVC",
    orderSummary: "Resumen del pedido",
    planLineFollowers: (n) => `${n} seguidores`,
    launchDiscount: "50% de descuento de lanzamiento",
    // Reposición automática. Se informa dentro del resumen, debajo del total.
    autoRefillLabel: (p) => `Mantén tu cuenta creciendo — $${p}/mes`,
    autoRefillDisclosure: (trial, cycle) => `Comienza en ${trial} días. Se renueva cada ${cycle} días. Cancela cuando quieras.`,
    // Checkout-only name for the usa addon — the visualizer toggle keeps its own.
    addonUsa: "Segmentación EE. UU.",
    dueToday: "Total a pagar hoy",
    processing: "Procesando...",
    secureCheckout: "Pago seguro",
    errEmail: "Por favor ingresa un correo electrónico válido.",
    errUsername: "Por favor ingresa tu nombre de usuario.",
    errUsernameIsEmail: (platform) => `Por favor ingresa tu usuario de ${platform}, no tu correo electrónico.`,
    errGeneric: "Algo salió mal. Por favor intenta de nuevo.",
    loginPrompt: "Ya tienes una cuenta con este correo. Ingresa tu contraseña para continuar.",
    loginPasswordPlaceholder: "Tu contraseña",
    loginCta: "Iniciar sesión y continuar",
    loginPasswordRequired: "Por favor ingresa tu contraseña.",
    successHeading: "¡Todo listo!",
    successBody: (handle) => `Estamos empezando el crecimiento en @${handle} ahora mismo. Crea una contraseña para acceder a tu panel.`,
    passwordPlaceholder: "Crea una contraseña (8+ caracteres)",
    passwordTooShort: "La contraseña debe tener al menos 8 caracteres.",
    goToDashboard: "Ir a mi panel",
    // Complemento de interacción de un clic en la pantalla de éxito.
    engagementTitle: (n) => `Tus ${n} nuevos seguidores están llegando`,
    engagementSub: "Agrega likes y vistas para que tus publicaciones no se vean vacías — 5,000 likes y 10,000 vistas, repartidos entre tus publicaciones recientes.",
    engagementCta: "Agregar por $9.98",
    engagementDone: "La interacción va en camino a tus publicaciones recientes.",
    // La mitad del paquete otra vez, a mitad de precio — el mismo precio por
    // seguidor que el paquete.
    upgradeFollowers: (n) => `Añade ${n} seguidores más`,
    upgradeFollowersLine: (n) => `+${n} seguidores`,
    upgradeFollowersSub: "Al mismo precio por seguidor — se entrega con tu pedido.",
    boostEngagement: "Impulsar Interacción+",
    boostEngagementSub: "Más vistas y alcance en cada publicación",
    planMicro: "Starter",
    planInfluencer: "Core",
    planBusiness: "Elite",
    featStarterFollowers: "200 seguidores",
    featStarterTargeting: "Segmentación de audiencia con IA",
    featStarterNoPassword: "Sin contraseña",
    featStarterCancel: "Cancela cuando quieras",
    featBasicFollowers: "1,200 seguidores",
    featBasicTargeting: "Segmentación de audiencia con IA mejorada",
    featBasicTools: "Asistente de contenido con IA",
    featBasicEngagement: "Soporte prioritario",
    featGrowthStarts: "El crecimiento de seguidores empieza al instante",
    featProPriority: "Soporte y entrega prioritarios",
    featProFollowers: "4,000 seguidores",
    featProTargeting: "Segmentación de audiencia con IA premium",
    featProManager: "Gerente de cuenta dedicado",
    summaryFollowersStarter: "200 seguidores",
    summaryFollowersBasic: "1,200 seguidores",
    summaryFollowersPro: "4,000 seguidores",
  },
};

export default lang;
